import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Propiedad from '../views/Propiedad.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/propiedad/:id',
    component: Propiedad
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
